'use strict'

import angular from 'angular'

import buySheetFieldComponentHtmlUrl from './buySheetField.component.html'

angular.module('buySheet.components').component('buySheetField', {
    templateUrl: buySheetFieldComponentHtmlUrl,
    bindings: {
        field: '<',
    },
    controllerAs: 'vm'
})